module.exports = __webpack_public_path__ + "img/721.47ce627c.png";